<template>
  <div>
   <div class="md-layout">
     <div class="md-layout-item md-size-50 defectlabel">
      <label><small v-if="hotkey">({{hotkey}}) </small>{{label}}</label>
     </div>
     <div class="md-layout-item md-size-50">
      <div class="checkline">
        <md-radio @change="changed(0)" v-model="myValue" class="md-primary" :value="0" ></md-radio>
        <md-radio @change="changed(1)" v-model="myValue" :value="1"></md-radio>
        <md-radio @change="changed(2)" v-model="myValue" :value="2"></md-radio>
      </div>
     </div>
   </div>
  </div>
</template>

<style>
label input  {
  display:inline !important;
  margin-left:1em !important;
  font-size:12px !important;
}
</style>

<script>

export default {
  name: 'tristate',
  data: () => ({
  }),
  props: ['label', 'value', 'hotkey'],
  model: {
    prop: 'value',
    event: 'valuechange'
  },
  computed: {
    myValue: {
      get: function () {
        return this.value === undefined ? 0 : this.value
      },
      set: function (newValue) {
        this.$emit('valuechange', newValue)
        return newValue
      }
    }
  },
  methods: {
    changed: function (value) {
      this.$emit('change', value)
    },
    reset: function () {
      this.myValue = 0
      // this.value = 0
    },
    toggle: function () {
      if (this.myValue === 0) {
        this.myValue = 2
        return
      }
      this.myValue--
      // this.value--
      // if (this.myValue > 2) {
      // this.myValue = 0
      // this.value = 0
      // }
      // if (this.myValue < 0) {
      // this.myValue = 2
      // this.value = 2
      // }
    }
  },
  created: function () {
    this.reset()
  }
}
</script>

<style lang="scss" >
.checkline {
  position:relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.checkline:before {
  position: absolute;
  left: 0;
  top: calc(50% - 2px);
  height: 4px;
  background: #ccc;
  content: "";
  width: 100%;
  display: block;
}
.checkline .md-radio{
  margin-right:0px;
  background-color:#fff
}
.defectlabel {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TriState.vue